"use client"
import React, { useEffect } from 'react';
import './About.css';
import { motion } from 'framer-motion';
import { Sparkels } from '../../Components';

export default function About() {

  useEffect(() => {
    document.body.classList.add('darkMode');
    document.body.classList.add('dark');
  }, []);

  return (
    <div className='about_container'>
      <motion.div
        initial={{ opacity: 0.0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.1,
          duration: 0.8,
          ease: "easeInOut",
        }}
        className="about_header"
      >
        <h3 className='about_title'>
          About ChessCloud
        </h3>
        <Sparkels />
        <div className="font-extralight text-base md:text-xl text-neutral-200 py-4 w-[100%] max-w-[800px] text-center">
          Revolutionizing chess analysis with cutting-edge cloud technology
        </div>
      </motion.div>
      
      <div className='about_content'>
        <motion.div
          initial={{ opacity: 0.0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.1,
            duration: 0.6,
            ease: "easeInOut",
          }}
          viewport={{ once: true, amount: 0.3 }}
          className="about_section"
        >
          <h4 className="about_section_title">🆓 Completely Free Platform</h4>
          <p className="about_text">
            ChessCloud is 100% free to use with no hidden costs or premium tiers. We believe that 
            powerful chess analysis tools should be accessible to everyone, regardless of their 
            financial situation. Enjoy unlimited access to all features without any restrictions.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0.0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.2,
            duration: 0.6,
            ease: "easeInOut",
          }}
          viewport={{ once: true, amount: 0.3 }}
          className="about_section"
        >
          <h4 className="about_section_title">📚 Revolutionary Variation Books</h4>
          <p className="about_text">
            Experience a completely new way to create and manage your opening repertoire. Our 
            innovative variation book system allows you to build, organize, and study your openings 
            with unprecedented ease. Create interactive trees, add notes, and track your progress 
            like never before.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0.0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.3,
            duration: 0.6,
            ease: "easeInOut",
          }}
          viewport={{ once: true, amount: 0.3 }}
          className="about_section"
        >
          <h4 className="about_section_title">🎯 Our Mission</h4>
          <p className="about_text">
            At ChessCloud, we believe that every chess player deserves access to world-class analysis tools. 
            Our mission is to democratize chess improvement by providing powerful, cloud-based analysis 
            capabilities that were once only available to grandmasters and professional players.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0.0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.4,
            duration: 0.6,
            ease: "easeInOut",
          }}
          viewport={{ once: true, amount: 0.3 }}
          className="about_section"
        >
          <h4 className="about_section_title">⚡ What We Offer</h4>
          <p className="about_text">
            ChessCloud harnesses the power of advanced chess engines like Stockfish and Leela Chess Zero 
            to provide deep position analysis, tactical training, and game review capabilities. Our platform 
            offers real-time analysis, opening exploration, endgame studies, and personalized training 
            recommendations tailored to your playing style and skill level.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0.0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.5,
            duration: 0.6,
            ease: "easeInOut",
          }}
          viewport={{ once: true, amount: 0.3 }}
          className="about_section"
        >
          <h4 className="about_section_title">☁️ Cloud-Powered Analysis</h4>
          <p className="about_text">
            Unlike traditional chess software that requires powerful hardware, ChessCloud runs entirely 
            in the cloud, giving you access to supercomputer-level analysis from any device. Whether 
            you're a beginner looking to understand basic tactics or a master seeking to refine your 
            opening repertoire, our platform scales to meet your needs with lightning-fast analysis 
            and intuitive visualizations.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0.0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.6,
            duration: 0.6,
            ease: "easeInOut",
          }}
          viewport={{ once: true, amount: 0.3 }}
          className="about_section"
        >
          <h4 className="about_section_title">🌟 Join Our Community</h4>
          <p className="about_text">
            Join thousands of chess enthusiasts who have already discovered the power of cloud-based 
            analysis. From casual players to titled masters, our community spans all skill levels and 
            backgrounds, united by a shared passion for the royal game. Start your journey today and 
            experience chess analysis like never before.
          </p>
        </motion.div>
      </div>
    </div>
  )
}
